var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32.00390625,
    viewBox: "0 0 32 32.00390625",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 2.00348C30 1.19723 29.5125 0.465979 28.7625 0.153479C28.0125 -0.159021 27.1562 0.0159794 26.5812 0.584729L23.8563 3.31598C20.8563 6.316 16.7875 8.0035 12.5437 8.0035L12 8.0035L10 8.0035L4 8.0035C1.79375 8.0035 0 9.79725 0 12.0035L0 18.0035C0 20.2097 1.79375 22.0035 4 22.0035L4 30.0035C4 31.1098 4.89375 32.0035 6 32.0035L10 32.0035C11.1062 32.0035 12 31.1098 12 30.0035L12 22.0035L12.5437 22.0035C16.7875 22.0035 20.8563 23.691 23.8563 26.691L26.5812 29.416C27.1562 29.991 28.0125 30.1597 28.7625 29.8472C29.5125 29.5347 30 28.8097 30 27.9972L30 18.7785C31.1625 18.2285 32 16.7472 32 15.0035C32 13.2598 31.1625 11.7785 30 11.2285L30 2.00348ZM26 6.79725L26 15.0035L26 23.2097C22.325 19.866 17.5312 18.0035 12.5437 18.0035L12 18.0035L12 12.0035L12.5437 12.0035C17.5312 12.0035 22.325 10.141 26 6.79725Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.cf022b19caf995604de2c8bf5567261f.svg";
export { ForwardRef as ReactComponent };